import { Outlet } from "react-router-dom";
import { Header } from "../Header/Header";
import { Suspense } from "react";
import css from "./SharedLayout.module.css";
import { Footer } from "components/Footer/Footer";
import { Toaster } from "react-hot-toast";


export const SharedLayout = () => {
    return (
        <>
        <div className={css.container}>
            <Header />
            
            <Suspense fallback={null}>
                <Outlet />
            </Suspense>
            <Footer />
            <Toaster />
        </div>
        </>
    );
};





